export default __webpack_public_path__ + "static/media/blackmissingtext.cbe065be.png";